//backend/src/store.js
import { writable } from 'svelte/store';

export const isAuthenticated = writable(false);

export const usersStore = writable([]);
export const rolesStore = writable([]);
export const permissionStore = writable([]);
export const gostergelerStore = writable([]);
export const formullerStore = writable([]);
export const degerlerStore = writable([]);
export const userGosStore = writable([]);
export const selectedUser = writable(null); // Yeni store
export const selectedRolles = writable(null); // Yeni store
export const selectedGosterge = writable(null); // null olarak başlat
export const selectedFormul = writable(null); // null olarak başlat
export const selectedDeger = writable(null); // null olarak başlat
export const selectedUserGostPer = writable(null); // null olarak başlat
export const selectedPriv = writable(new Set());
export const isEditing = writable(false); // Yeni store
export const isRoleEditing = writable(false); // Yeni store
export const isGostergeEditing = writable(false); // Yeni store
export const isFormulEditing = writable(false); // Yeni store
export const isDegerEditing = writable(false); // Yeni store
export const isDegerlerEditing = writable(false); // Yeni store
export const isPerEditing = writable(false); // Yeni store
export const selectedGostergeDegerSayisi = writable('');
export const selectedDegerlerDegerSayisi = writable('');
